import cx from "classnames";

import styles from "./CardContainer.module.css";

function CardContainer({ className = "", children = null, width = "780px" }) {
  const hightAndwidth = {
    width: width,
  };

  return (
    <div className={cx(className, styles.customStyle)} style={hightAndwidth}>
      {children}
    </div>
  );
}

export default CardContainer;
